<template>
  <nt-auth-template>
    <v-row dense align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card color="loginBackground">
          <v-card-text class="text-center">
            <img class="my-3" :src="info.app_logo"/>
            <h3 class="text-h5 mt-4 mb-0">Primeiro Acesso (Registro)</h3>
          </v-card-text>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-form @submit.prevent="submit()" v-model="form.valid" lazy-validation method="post" id="register" ref="form">
                  <v-text-field
                    name="email"
                    label="Email"
                    v-model="user.email"
                    required
                    prepend-icon="mdi-account"
                    type="email"
                    :error-messages="error.messages.email"
                    :autofocus="focusUsernameInput"
                    color="loginFont"/>
                  <v-text-field
                    name="password"
                    label="Senha"
                    v-model="user.password"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    :autofocus="!focusUsernameInput"
                    :error-messages="error.messages.password"
                    color="loginFont"/>
                  <v-text-field
                    name="password-confirmation"
                    label="Confirmar Senha"
                    v-model="user.password_confirmation"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    :autofocus="!focusUsernameInput"
                    color="loginFont"/>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text exact :to="{ name: 'auth.login' }">Cancelar</v-btn>
            <v-spacer/>
            <v-btn exact type="submit" form="register" color="loginButton">Cadastrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </nt-auth-template>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import Storage from '@/services/Storage'
import NtAuthTemplate from '@/components/Utils/NtAuthTemplate'

const sessionStorage = new Storage(window.sessionStorage)

export default {
  components: {
    NtAuthTemplate
  },
  mounted () {
    if (this.isAuthenticated) {
      this.$router.push({ name: 'ambienteAluno.dashboard' })
    }
  },
  data () {
    return {
      user: {
        enrollment: sessionStorage.get('first_access_enrollment'),
        birth_date: sessionStorage.get('first_access_birth_date'),
        email: '',
        password: '',
        password_confirmation: ''
      },
      error: {
        error: false,
        messages: []
      },
      form: {
        valid: false
      },
      passVisibility: false
    }
  },
  methods: {
    submit () {
      this.error.error = false
      this.error.messages = []
      if (this.$refs.form.validate()) {
        store.dispatch('App/firstAccessRegister', this.user)
          .then((response) => {
            this.clear()
            this.$router.push({ name: 'auth.login' })
          })
          .catch((responseError) => {
            this.error.error = true
            this.user.password = ''
            this.user.password_confirmation = ''
            if (responseError.status === 422) {
              this.error.messages = responseError.data
              this.form.valid = false
            } else {
              this.$toasted.error(responseError.data.message)
            }
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated',
      info: ['App/info']
    }),
    focusUsernameInput () {
      return this.user.email === ''
    }
  }
}

</script>

<style scoped>
.login-bg {
  background: #ffffff url("/static/img/bg_login.jpg") no-repeat fixed center !important;
}

.loginFont--text >>> *{
  color: inherit !important;
}
</style>
